import axios from 'axios'
import config from "@/config/config";
import storage from "@/utils/storage";
/**
 * 查询json配置
 * @returns {*}
 */
export const getJson = () => {
    return axios({
        baseURL: config.serverIp,
        url: '/officialWebsite/json',
        method: 'GET',
    })
}
/**
 * 获取球员列表
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export const getPlayerList = () => {
    return axios({
        baseURL: config.serverIp,
        url: '/officialWebsite/player?lang=zh-CN（国服）',
        method: 'GET',
    })
}
/**
 * 查询文章、攻略
 * @param params
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export const getArticles = params => {
    return axios({
        baseURL: config.serverIp,
        url: '/officialWebsite/articles',
        method: 'GET',
        params
    })
}

/**
 * 查询账号信息
 * @param invitecode
 * @returns {*}
 */
export const getAccountInfo = invitecode => {
    return axios({
        baseURL: config.serverIp,
        url: '/get_shop_playerinfo',
        method: 'GET',
        params: {
            invitecode
        }
    })
}

/**
 * 查询专属礼物是否领取过
 * @param account
 * @returns {*}
 */
export const getReceiveStatus = account => {
    return axios({
        baseURL: config.serverIp,
        url: '/officialWebsite/receive-status',
        method: 'GET',
        params: {
            account
        },
        headers: {
            'Content-Type': 'application/json',
            authorization: 'Bearer ' + storage.getWithExpiry('WEBSITE_PC_TOKEN')
        }
    })
}
/**
 * 领取专属礼物
 * @param account
 * @returns {*}
 */
export const getReceive = account => {
    return axios({
        baseURL: config.serverIp,
        url: '/officialWebsite/receive',
        method: 'GET',
        params: {
            account
        },
        headers: {
            'Content-Type': 'application/json',
            authorization: 'Bearer ' + storage.getWithExpiry('WEBSITE_PC_TOKEN')
        }
    })
}
/**
 * 根据账号查询卡片时长
 * @param account
 * @returns {*}
 */
export const getCardDuration = (account) => {
    return axios({
        baseURL: config.serverIp,
        url: '/officialWebsite/card-duration',
        method: 'GET',
        params: {
            account
        }
    })
}

/**
 * 创建订单
 * @param data
 * @returns {*}
 */
export const createOrder = data => {
    return axios({
        baseURL: config.serverIp,
        url: '/officialWebsite/create',
        method: 'POST',
        data,
        headers: {
            'Content-Type': 'application/json',
            authorization: 'Bearer ' + storage.getWithExpiry('WEBSITE_PC_TOKEN')
        }
    })
}
/**
 * 查询订单详情
 * @param data
 * @returns {*}
 */
export const getOrderDetail = data => {
    return axios({
        baseURL: config.serverIp,
        url: '/officialWebsite/order-detail',
        method: 'POST',
        data,
        headers: {
            'Content-Type': 'application/json',
            authorization: 'Bearer ' + storage.getWithExpiry('WEBSITE_PC_TOKEN')
        }
    })
}

/**
 * 订单支付
 * @param data
 * @returns {*}
 */
export const payOrder = data => {
    return axios({
        baseURL: config.serverIp,
        url: '/officialWebsite/order-pay',
        method: 'POST',
        data,
        headers: {
            'Content-Type': 'application/json',
            authorization: 'Bearer ' + storage.getWithExpiry('WEBSITE_PC_TOKEN')
        }
    })
}

/**
 * 支付宝支付连接
 * @param orderNo
 * @returns {*}
 */
export const aliPayLink = (orderNo) => {
    return axios({
        baseURL: config.serverIp,
        url: '/officialWebsite/ali-pay-link',
        method: 'GET',
        params: {
            orderNo
        }
    })
}

/**
 * 校验玩家信息
 * @param params
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export const checkPlayerFun = params => {
    return axios({
        baseURL: config.serverIp,
        url: '/officialWebsite/website-check-player',
        method: 'GET',
        params
    })
}
/**
 * 获取登录状态
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export const loginStateFun = () => {
    return axios({
        baseURL: config.serverIp,
        url: '/officialWebsite/check-state-info',
        method: 'GET'
    })
}
/**
 * 发送验证码
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export const sendMessageFun = (phone) => {
    return axios({
        baseURL: config.serverIp,
        url: `/officialWebsite/send-message`,
        params: {
            phone
        }
    })
}
/**
 * 验证短信
 * @param phone
 * @param code
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export const checkMessageFun = (phone, code, remember) => {
    return axios({
        baseURL: config.serverIp,
        url: `/officialWebsite/check-message`,
        params: {
            phone: phone,
            code: code,
            remember: remember
        }
    })
}
/**
 * 解析code
 * @param code
 * @param type
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export const getAppletOrWechatLogin = (code, type) => {
    return axios({
        baseURL: config.serverIp,
        url: `/officialWebsite/login`,
        method: 'post',
        params: {
            type,
            code
        }
    })
}
/**
 * 查询用户信息
 * @param uuid
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export const getPlayerInfoFun = (uuid) => {
    return axios({
        baseURL: config.serverIp,
        url: `/officialWebsite/player-info-uuid`,
        method: 'get',
        params: {
            uuid
        }
    })
}
/**
 * 删除用户信息
 * @param uuid
 * @returns {Promise<AxiosResponse<any>> | *}
 */
export const delPlayerInfoFun = (uuid) => {
    return axios({
        baseURL: config.serverIp,
        url: `/officialWebsite/del-player-info`,
        method: 'delete',
        params: {
            uuid
        }
    })
}